// Estilo del mapa (12-oct-2026). Se elige en Configuración y queda guardado en este navegador.
// OpenFreeMap: mapas vectoriales libres, sin clave y con uso comercial permitido.
// "clasico" es el OpenStreetMap de siempre (imágenes), que además es el respaldo si el
// navegador no puede dibujar mapas vectoriales.
export const ESTILOS_MAPA = [
    { id: 'liberty', nombre: 'Liberty', detalle: 'Colores suaves, calles nítidas (el más parecido a Google)' },
    { id: 'positron', nombre: 'Positron', detalle: 'Gris claro y minimalista: los puntos resaltan más' },
    { id: 'clasico', nombre: 'Clásico', detalle: 'OpenStreetMap de siempre, más cargado de colores' },
];
const CLAVE = 'mapa_estilo';

export function estiloMapa() {
    try { return localStorage.getItem(CLAVE) || 'liberty'; } catch { return 'liberty'; }
}

export function guardarEstiloMapa(id) {
    try { localStorage.setItem(CLAVE, id); } catch { /* sin guardar: queda el de siempre */ }
    window.dispatchEvent(new CustomEvent('mapa-estilo', { detail: id }));
}

// Zona de trabajo: AMBA con margen (de La Plata a Pilar/Escobar, de Cañuelas/Luján a la costa)
export const LIMITES_AMBA = [[-35.40, -59.40], [-34.10, -57.60]];
export const CENTRO_AMBA = [-34.64, -58.45];
